export default function OverlaySkeleton({ close, children }) {
    return (
        <div className={"overlay-modal"}>
            <div
                onClick={close}
                className={"overlay-backdrop row m-0 w-100 h-100 d-flex flex-row-reverse"}
            >
                <div className={"overlay-panel col-6 col-12-md bg-light border-2 h-100 black overflow-scroll"}>
                    {children}
                </div>
            </div>
        </div>
    )
}
